﻿$(function () {
    getHosts();

    $('.host-next.left').on('click', function () {
        var page = parseInt($('.host-pages .selected').text());
        if (page > 1) {
            page--;
            getHosts(page);
        }
    });

    $('.host-next.right').on('click', function () {
        var page = parseInt($('.host-pages .selected').text());
        var total = $('.host-pages .host-page').length;
        if (page + 1 <= total) {
            page++;
            getHosts(page);
        }
    });
});

function getHosts(page) {
    if (!page) {
        page = parseInt($('.host-pages .selected').attr('page'));
    }

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/contents?id=host&size=16&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }

            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                var img = '/static/images/no-avatar.png';
                if (info.thumbnail_urls && info.thumbnail_urls.length > 0 && info.thumbnail_urls[0])
                    img = info.thumbnail_urls[0] + '?w=150&h=150&s=3';
                newlist += '<div class="host-item">\n' +
                    '<a href="' + ROOT + '/host/' + info.id + '" class="host-img">' +
                    '<img src="' + img + '"</a>\n' +
                    '<a href="' + ROOT + '/host/' + info.id + '" class="host-name">' + info.title + '</a>\n' +
                    '<div class="host-introduce">' + info.summary + '</div>\n' +
                    '<a href="' + ROOT + '/host/' + info.id + '" class="host-homepage"></a>\n' +
                    '</div>\n';
            }

            $('.host-list').html(newlist);

            if (page) page = parseInt(page);
            else page = 1;
            if (data.total) {
                var pages = '';
                var total = Math.ceil(data.total / 16);
                if (page - 2 > 0) {
                    pages += '<div class="host-page">' + (page - 2) + '</div>';
                }
                if (page - 1 > 0) {
                    pages += '<div class="host-page">' + (page - 1) + '</div>';
                }
                pages += '<div class="host-page selected">' + page + '</div>';
                if (page + 1 <= total) {
                    pages += '<div class="host-page">' + (page + 1) + '</div>';
                }
                if (page + 2 <= total) {
                    pages += '<div class="host-page">' + (page + 2) + '</div>';
                }
                $('.host-pages').html(pages);

                $('.host-page').off('click');
                $('.host-page').on('click', function () {
                    if ($(this).hasClass('selected')) return;
                    var page = $(this).text();
                    getHosts(page);
                });
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
}